"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CashBack = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Bubble = _interopRequireDefault(require("../Bubble"));
var _MobilePopupBottom = _interopRequireDefault(require("../MobilePopupBottom"));
var _AvatarIcon = _interopRequireDefault(require("../AvatarIcon"));
var _CashBackIcon = require("./components/CashBackIcon");
var _formatCashback = require("./utils/formatCashback");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var CashBack = exports.CashBack = function CashBack(_ref) {
  var className = _ref.className,
    cashbackTooltipText = _ref.cashbackTooltipText,
    label = _ref.label,
    isMobile = _ref.isMobile,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'm' : _ref$size,
    avatarPath = _ref.avatarPath,
    _ref$hasCashbackLabel = _ref.hasCashbackLabel,
    hasCashbackLabel = _ref$hasCashbackLabel === void 0 ? true : _ref$hasCashbackLabel,
    count = _ref.count,
    cashbackIconWebp = _ref.cashbackIconWebp,
    cashbackIconPng = _ref.cashbackIconPng,
    labelColor = _ref.labelColor,
    textColor = _ref.textColor;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    showPopup = _useState2[0],
    setShowPopup = _useState2[1];
  var openPopup = function openPopup() {
    return setShowPopup(true);
  };
  var closePopup = function closePopup() {
    return setShowPopup(false);
  };
  var labelText = label || 'Кешбэк';
  var Icon = (0, _react.useMemo)(function () {
    if (cashbackIconWebp && cashbackIconPng) {
      var CustomIcon = function CustomIcon() {
        return /*#__PURE__*/_react["default"].createElement(_CashBackIcon.CashBackCustomIcon, {
          size: size,
          cashbackIconWebp: cashbackIconWebp,
          cashbackIconPng: cashbackIconPng
        });
      };
      CustomIcon.displayName = 'CustomIcon';
      return CustomIcon;
    }
    return _CashBackIcon.CashBackIcon;
  }, [size, cashbackIconWebp, cashbackIconPng]);
  var CashBackComponent = function CashBackComponent() {
    return /*#__PURE__*/_react["default"].createElement(Wrapper, {
      $size: size,
      $labelColor: labelColor,
      $textColor: textColor,
      $withBorder: className === null || className === void 0 ? void 0 : className.includes('withBorder'),
      $withClientAccountStyles: className === null || className === void 0 ? void 0 : className.includes('clientAccount'),
      $withColumnLayoutStyles: (className === null || className === void 0 ? void 0 : className.includes('column')) && !!label,
      $withAbsoluteMobileLayoutStyles: (className === null || className === void 0 ? void 0 : className.includes('hotelMobile')) && !cashbackTooltipText,
      $withAbsoluteDesktopLayoutStyles: (className === null || className === void 0 ? void 0 : className.includes('hotelDesktop')) && !cashbackTooltipText,
      className: className,
      "data-testid": "TEST_ID_CASHBACK"
    }, hasCashbackLabel && /*#__PURE__*/_react["default"].createElement("span", null, labelText), /*#__PURE__*/_react["default"].createElement(FlexContainer, null, /*#__PURE__*/_react["default"].createElement("span", null, (0, _formatCashback.formatCashback)(count)), /*#__PURE__*/_react["default"].createElement(Icon, {
      size: size
    })), avatarPath && /*#__PURE__*/_react["default"].createElement(_AvatarIcon["default"], {
      avatarUrl: avatarPath,
      size: 20
    }));
  };
  if (!cashbackTooltipText) {
    return /*#__PURE__*/_react["default"].createElement(CashBackComponent, null);
  }
  return isMobile ? /*#__PURE__*/_react["default"].createElement(StyledButton, {
    type: "button",
    onClick: openPopup,
    onKeyDown: openPopup,
    "data-testid": "TEST_ID_CASHBACK_MOBILE_WITH_TOOLTIP",
    $withAbsoluteMobileLayoutStyles: className === null || className === void 0 ? void 0 : className.includes('hotelMobile')
  }, /*#__PURE__*/_react["default"].createElement(CashBackComponent, null), /*#__PURE__*/_react["default"].createElement(_MobilePopupBottom["default"], {
    options: {
      showHandlebar: true
    },
    visible: showPopup,
    onClick: closePopup
  }, cashbackTooltipText)) : /*#__PURE__*/_react["default"].createElement(StyledBubble, {
    text: cashbackTooltipText,
    width: 265,
    "data-testid": "TEST_ID_CASHBACK_DESKTOP_WITH_TOOLTIP",
    $withAbsoluteDesktopLayoutStyles: className === null || className === void 0 ? void 0 : className.includes('hotelDesktop')
  }, /*#__PURE__*/_react["default"].createElement(CashBackComponent, null));
};
var flex = (0, _styledComponents.css)(["display:flex;align-items:center;gap:4px;"]);
var absoluteDesktopLayoutStyles = (0, _styledComponents.css)(["position:absolute;z-index:2;right:8px;top:8px;"]);
var absoluteMobileLayoutStyles = (0, _styledComponents.css)(["position:absolute;z-index:2;left:15px;top:15px;"]);
var FlexContainer = _styledComponents["default"].div.withConfig({
  displayName: "CashBack__FlexContainer",
  componentId: "sc-lpmkg8-0"
})(["", ""], flex);
var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "CashBack__Wrapper",
  componentId: "sc-lpmkg8-1"
})(["", " width:max-content;padding:5px 8px;", ";background-color:", ";border-radius:var(--border-radius);color:", ";font-size:", "px;line-height:", "px;font-style:normal;font-weight:400;", " ", " ", " ", ""], flex, function (_ref2) {
  var $withBorder = _ref2.$withBorder;
  return $withBorder && (0, _styledComponents.css)(["border:1px solid"]);
}, function (_ref3) {
  var $labelColor = _ref3.$labelColor;
  return $labelColor || (0, _styledComponents.css)(["var(--white)"]);
}, function (_ref4) {
  var $textColor = _ref4.$textColor;
  return $textColor || (0, _styledComponents.css)(["var(--black)"]);
}, function (_ref5) {
  var $size = _ref5.$size;
  return {
    s: 10,
    m: 12,
    ml: 14,
    l: 16
  }[$size];
}, function (_ref6) {
  var $size = _ref6.$size;
  return {
    s: 12,
    m: 14,
    ml: 16,
    l: 20
  }[$size];
}, function (_ref7) {
  var $withClientAccountStyles = _ref7.$withClientAccountStyles;
  return $withClientAccountStyles && (0, _styledComponents.css)(["font-size:16px;line-height:20px;margin:12px auto 4px;background:transparent;"]);
}, function (_ref8) {
  var $withColumnLayoutStyles = _ref8.$withColumnLayoutStyles;
  return $withColumnLayoutStyles && (0, _styledComponents.css)(["flex-direction:column;"]);
}, function (_ref9) {
  var $withAbsoluteMobileLayoutStyles = _ref9.$withAbsoluteMobileLayoutStyles;
  return $withAbsoluteMobileLayoutStyles && (0, _styledComponents.css)(["", ""], absoluteMobileLayoutStyles);
}, function (_ref10) {
  var $withAbsoluteDesktopLayoutStyles = _ref10.$withAbsoluteDesktopLayoutStyles;
  return $withAbsoluteDesktopLayoutStyles && (0, _styledComponents.css)(["", ""], absoluteDesktopLayoutStyles);
});
var StyledButton = _styledComponents["default"].button.withConfig({
  displayName: "CashBack__StyledButton",
  componentId: "sc-lpmkg8-2"
})(["border:none;", ""], function (_ref11) {
  var $withAbsoluteMobileLayoutStyles = _ref11.$withAbsoluteMobileLayoutStyles;
  return $withAbsoluteMobileLayoutStyles && (0, _styledComponents.css)(["", ""], absoluteMobileLayoutStyles);
});
var StyledBubble = (0, _styledComponents["default"])(_Bubble["default"]).withConfig({
  displayName: "CashBack__StyledBubble",
  componentId: "sc-lpmkg8-3"
})(["", ""], function (_ref12) {
  var $withAbsoluteDesktopLayoutStyles = _ref12.$withAbsoluteDesktopLayoutStyles;
  return $withAbsoluteDesktopLayoutStyles && (0, _styledComponents.css)(["", ""], absoluteDesktopLayoutStyles);
});